module.exports = __webpack_public_path__ + "static/media/westinchennai07.60a7db68.jpg";